import type { ReactNode } from 'react';

export function FullPageMessage({ children }: { children: ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-5 text-muted">
      <p role="status">{children}</p>
    </main>
  );
}
